import { render } from "./LLMProject.vue?vue&type=template&id=48cd9bba"
import script from "./LLMProject.vue?vue&type=script&lang=js"
export * from "./LLMProject.vue?vue&type=script&lang=js"

import "./LLMProject.vue?vue&type=style&index=0&id=48cd9bba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__